module.exports = __webpack_public_path__ + "static/media/a47.01438b48.jpg";